module.exports = "/dist/assets/images/arrow-black.svg";